/* unplugin-vue-components disabled */import { render } from "./Logical2DQuestionSelector.vue?vue&type=template&id=985b2668&scoped=true"
import script from "./Logical2DQuestionSelector.vue?vue&type=script&lang=js"
export * from "./Logical2DQuestionSelector.vue?vue&type=script&lang=js"

import "./Logical2DQuestionSelector.vue?vue&type=style&index=0&id=985b2668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985b2668"]])

export default __exports__